/* Stylesheet */

.stats_container {
  height: 92%;

  :global {
    .swiper {
      height: 100% !important;
    }

    .swiper-wrapper {
      height: 100% !important;
    }
  }
}
